/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import {
  Box,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from '@mui/material';
import { useMemo } from 'react';

import { CalendarSuggestionsSchedulingInspectionData } from '../../../api/workOrders/types';
import { CancelIcon } from '../../../assets/scheduleHistoryTable/CancelIcon/CancelIcon';
import { CheckCircleIcon } from '../../../assets/scheduleHistoryTable/CheckCircleIcon/CheckCircleIcon';
import { HourglassIcon } from '../../../assets/scheduleHistoryTable/HourglassIcon/HourglassIcon';

const renderStatus = (
  status: CalendarSuggestionsSchedulingInspectionData['status']
): JSX.Element => {
  switch (status) {
    case 'APPROVED':
      return (
        <Box display="flex" alignItems="center" gap={1}>
          <CheckCircleIcon />
          <Typography>Aceito</Typography>
        </Box>
      );
    case 'REJECTED':
      return (
        <Box display="flex" alignItems="center" gap={1}>
          <CancelIcon />
          <Typography>Recusado</Typography>
        </Box>
      );
    case 'PENDING':
      return (
        <Box display="flex" alignItems="center" gap={1}>
          <HourglassIcon />
          <Typography>Aguardando</Typography>
        </Box>
      );
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>;
  }
};

const renderResponse = ({
  row,
}: {
  row: CalendarSuggestionsSchedulingInspectionData;
}): React.ReactNode => {
  if (row.responded_at) {
    return `${Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short',
    }).format(new Date(row.responded_at))} por ${
      row.responder_role ? row.engineer.name : row.responsible
    }`;
  }

  return '-';
};

interface RemoteInspectionTableHistoryProps {
  rows?: CalendarSuggestionsSchedulingInspectionData[];
  sx?: SxProps<Theme>;
}

export function RemoteInspectionTableHistory({
  rows,
  sx,
}: RemoteInspectionTableHistoryProps = {}): JSX.Element {
  const memorizedTable = useMemo(
    () => (
      <TableBody>
        {rows?.map((row) => (
          <TableRow key={row.id}>
            <TableCell>
              {new Intl.DateTimeFormat('pt-BR', {
                dateStyle: 'short',
              }).format(new Date(row.created_at))}
            </TableCell>
            <TableCell>{renderStatus(row.status)}</TableCell>
            <TableCell>{row.rejection_reason || '-'}</TableCell>
            <TableCell>
              {renderResponse({
                row,
              })}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    ),
    [rows]
  );

  return (
    <Box
      sx={{
        maxWidth: '1008px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        border: '1px solid #D0D5DD',
        padding: '24px',
        marginBottom: '40px',
      }}
    >
      <Typography
        sx={{
          marginBottom: '24px',
        }}
      >
        Status do Agendamento
      </Typography>
      <TableContainer sx={sx}>
        <Table>
          <TableHead
            sx={{
              backgroundColor: '#F2F4F7',
              '& th': {
                fontWeight: 'bold',
                color: '#344054',
                fontSize: '14px',
                lineHeight: '20px',
              },
            }}
          >
            <TableRow>
              <TableCell>
                <strong>Data de Criação</strong>
              </TableCell>
              <TableCell>
                <strong>Situação</strong>
              </TableCell>
              <TableCell>
                <strong>Motivo da Recusa</strong>
              </TableCell>
              <TableCell>
                <strong>Data de Aceite/Recusa</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          {memorizedTable}
        </Table>
      </TableContainer>
    </Box>
  );
}
